import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Shared/Loader';
import { useRef } from 'react';
import AddPurchaseProductList from './AddPurchaseProductList';
import AddPurchaseInvoice from './AddPurchaseInvoice';
import { selectSupplier } from '../../../../features/PurchaseSlice/PurchaseSlice';
import { format } from 'date-fns';
import useFetchData from '../../../../hooks/useFetchData';
import SupplierList from '../../../../hooks/SupplierList';
import { nextTenantNumber, useTenantNumbering } from '../../../../saas/tenantNumbering';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiPackage, FiTruck } from 'react-icons/fi';
import '../../Sales/AddSales/MobileDefaultSales.css';



const AddPurchase = ({ }) => {
    const legacySetting = useSelector((state) => state.info.settings);
    const tenantNumbering = useTenantNumbering();
    const setting = { ...(legacySetting || {}), ...tenantNumbering };
    const { posSupplier, isSupplier } = useSelector((state) => state.purchaseInvoice);
    const supply = useSelector((state) => state.purchaseInvoice.supplier);
    const { items } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/getpurchaseinvoice');
    const [isSearching, setIsSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [loading, setLoading] = useState(true);
    const [suppliers, setSuppliers] = useState([]);
    const [details, setDetails] = useState();
    const [currentSupplier, setCurrentSupplier] = useState([]);
    const [isInvoice, setIsInvoice] = useState(false);
    // const [isSupplier, setIsSupplier] = useState(false);
    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const supplierCodeRef = useRef('');
    const supplierRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');
    const dateRef = useRef('');
    const invoiceRef = useRef('');
    const [invoiceNo, setInvoiceNo] = useState('');

    const dispatch = useDispatch();
    const location = useLocation();
    const isMobileTransactionEditor = location.pathname === '/mobile/addpurchase';



    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsuppliers')
            .then(res => res.json())
            .then(data => {
                setSuppliers(data);
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        const myLength = nextTenantNumber(setting.Purchase_Invoice_Prefix, items.length);
        const isExist = items?.filter(memo => memo?.salesInvoice === myLength);
        const duplicate = isExist?.length ? true : false;

        if (duplicate) {
            // Increment the suffix to avoid duplicates
            const suffix = isExist.length + 1;
            setInvoiceNo(`${myLength}-${suffix}`);
        } else {
            setInvoiceNo(myLength);
        }
    }, [items, setting.Purchase_Invoice_Prefix]);


    if (loading) {
        return <Loader />
    }

    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = suppliers.filter(supplier => supplier.name.includes(searchText)
            || supplier.name.toLowerCase().includes(searchText) ||
            supplier.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    // const handleSelectSupplier = (suppliar) => {
    //     dispatch(selectSupplier(suppliar))
    //     setIsSearching(false)
    //     setSearchText('');

    // }

    // const handleSelectSupplier = (supplier) => {
    //     const opening = parseFloat(supplier?.opening)
    //     const url = `https://servers.thakurgaonexpress.com/rupkotha/filteredsupplier?code=${supplier?.code}`
    //     fetch(url)
    //         .then(res => res.json())
    //         .then(data => {
    //             console.log(data);
    //             const due = opening + data?.defaultTotalDue - data?.defaultTotalPayment;
    //             setCurrentSupplier({ ...supplier, due });
    //         })
    //     setIsSearching(false)
    //     setSearchText('');
    //     setIsSupplier(true);
    // }


    const handlePurchaseDetails = (event) => {
        const purchaseInvoice = event?.target?.value ?? invoiceRef.current?.value ?? (setting?.Auto_Purchase_Invoice ? invoiceNo : '');
        const supplierCode = supplierCodeRef.current.innerText;
        const purchaseSupplier = supplierRef.current.innerText;
        const purchaseAddress = addressRef.current.innerText;
        const purchasePhone = phoneRef.current.innerText;
        const purchaseOpening = openingRef.current.innerText;
        const purchaseDate = dateRef.current.value;
        const isExist = items?.filter(memo => memo?.purchaseInvoice === purchaseInvoice);
        const duplicate = isExist?.length ? true : false;
        // setIsInvoice(true);

        const updatedDetails = {
            purchaseInvoice: setting?.Auto_Purchase_Invoice ? invoiceNo : purchaseInvoice, supplierCode, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate, duplicate
        }
        if (!setting?.Auto_Purchase_Invoice) {
            updatedDetails.isExit = true;
            updatedDetails.duplicate = duplicate;
        }
        setIsInvoice(true);
        setDetails(updatedDetails)

    }


    if (isMobileTransactionEditor) {
        return <div className="mobile-sale-checkout mobile-purchase-checkout"><header className="mobile-sale-checkout__hero"><div><p className="mobile-sale-checkout__eyebrow"><FiPackage />Touch purchase checkout</p><h1>New purchase</h1><p>Invoice {invoiceNo || '—'}</p></div><Link className="mobile-sale-checkout__home" to="/mobile" aria-label="Back to mobile home"><FiArrowLeft /></Link></header><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiTruck />Supplier</h2><small>Tap to search</small></div><div className="mobile-sale-checkout__customer-picker"><SupplierList handlePurchaseDetails={handlePurchaseDetails} suppliers={suppliers} /></div><div className="mobile-sale-checkout__customer-summary"><div className="mobile-sale-checkout__customer-card"><small>Selected supplier</small><strong ref={supplierRef}>{posSupplier?.name || 'Choose a supplier'}</strong><span><span ref={supplierCodeRef}>{posSupplier?.code || '—'}</span> · <span ref={phoneRef}>{posSupplier?.phone || 'No phone'}</span></span><span ref={addressRef} className="hidden">{posSupplier?.address || '—'}</span></div><div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{Number(posSupplier?.due || 0).toFixed(2)}</strong></div></div></section><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Purchase details</h2><small>{isInvoice ? 'Invoice ready' : 'Choose supplier first'}</small></div><div className="mobile-sale-checkout__meta-grid"><div className="mobile-sale-checkout__field"><label>Purchase date</label><input ref={dateRef} defaultValue={today} type="date" /></div><div className="mobile-sale-checkout__field"><label>Invoice number</label><input ref={invoiceRef} disabled={setting?.Auto_Purchase_Invoice ? !isSupplier : false} onChange={handlePurchaseDetails} {...(setting?.Auto_Purchase_Invoice ? { value: invoiceNo, readOnly: true } : { defaultValue: '' })} type="text" placeholder="Invoice number" /></div></div>{details?.duplicate ? <p className="mobile-default-modal__error">This invoice number already exists. Change it before submitting.</p> : null}</section><section className="mobile-sale-checkout__section mobile-default-sale-checkout__products"><div className="mobile-sale-checkout__section-head"><h2>Product & cart</h2><small>Search, add, and review products</small></div><AddPurchaseProductList handlePurchaseDetails={setting?.Auto_Purchase_Invoice && handlePurchaseDetails} isSupplier={setting?.Auto_Purchase_Invoice && isSupplier} /><AddPurchaseInvoice details={details} isInvoice={isInvoice} isSupplier={isSupplier} /></section></div>;
    }
    return (
        <div className={`tenant-page text-xs${isMobileTransactionEditor ? ' mobile-default-editor' : ''}`}>
            <h1 className='tenant-page__heading tenant-page__heading--single'>Add A Purchase</h1>
            <div className='transaction-panel grid grid-cols-1 lg:grid-cols-12 gap-4 mt-4'>
                <div class="form-control w-full lg:w-60 max-w-xs mt-5 col-span-2">
                    <div class="form-control lg:w-60 mx-auto">
                        <SupplierList handlePurchaseDetails={handlePurchaseDetails} suppliers={suppliers} />
                        {/* <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Supplier" class="rounded-lg bg-gray-300 p-3  text-center  focus:border-blue-500 focus:outline-none w-full max-w-xs" />
                    </div>
                    <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isSearching ? 'h-16' : "h-8"} w-80 overflow-auto`}>
                        {
                            isSearching ? searchResult.map(supplier =>
                                <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>) :
                                suppliers.map(supplier =>
                                    <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>)
                        } */}
                    </div>
                </div>
                <div className='lg:col-span-6 mt-4 overflow-auto lg:lg:overflow-visible'>
                    <table class="table lg:w-1/2 lg:ml-32">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Supplier Code</th>
                                <th className='bg-primary text-white normal-case'>Supplier Name</th>
                                <th className='bg-primary text-white normal-case'>Supplier Address</th>
                                <th className='bg-primary text-white normal-case'>Mobile No</th>
                                <th className='bg-primary text-white normal-case'>Previews Due</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td ref={supplierCodeRef} className='h-8'>{posSupplier?.code}</td>
                                <td ref={supplierRef} className='h-8'>{posSupplier?.name}</td>
                                <td ref={addressRef}>{posSupplier?.address}</td>
                                <td ref={phoneRef}>{posSupplier?.phone}</td>
                                <td ref={openingRef}>{(posSupplier?.due)?.toFixed(2)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <br />
                <div className='lg:col-span-4 mt-4'>
                    <table class="table w-1/2 mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Select Date</th>
                                <th className='bg-primary text-white normal-case'>Invoice No</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            <tr className=''>
                                <td><input ref={dateRef} defaultValue={today} type="date" className='rounded-lg bg-gray-200 p-3  text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                <td><input ref={invoiceRef} disabled={setting?.Auto_Purchase_Invoice ? !isSupplier : ''} onChange={handlePurchaseDetails} {...(setting?.Auto_Purchase_Invoice ? { value: invoiceNo, readOnly: true } : { defaultValue: '' })} type="text" placeholder='Type Invoice' className='rounded-lg bg-gray-200 p-3 w-40 text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                            </tr>
                            {details?.duplicate && <tr className=''>
                                <td></td>
                                <td className='text-primary font-bold'>(Duplicate Please Change)</td>
                            </tr>}

                        </tbody>
                    </table>
                </div>
            </div>
            <div className='grid grid-cols-1 relative'>
                <AddPurchaseProductList handlePurchaseDetails={setting?.Auto_Purchase_Invoice && handlePurchaseDetails} isSupplier={setting?.Auto_Purchase_Invoice && isSupplier} />
                <AddPurchaseInvoice details={details} isInvoice={isInvoice} isSupplier={isSupplier} />
            </div>
        </div>
    );
};

export default AddPurchase;
